import { ListaSistemaTintometrico } from "app/api/classes/ProdutoApi";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { InputNumerico } from "app/components/inputs/InputNumerico";
import { Paginacao } from "app/components/itens-orcamento/paginacao/Paginacao";
import clsx from "clsx";
import { useFormik } from "formik";
import globalMU from "globalMU";
import React, { useState } from "react";

const estilosTabelas = require('../../../estilos/tabelas.module.scss').default
const estilosBotoes = require('../../../estilos/botoes.module.scss').default
const estilosInputs = require('../../../estilos/inputs.module.scss').default


export type PesquisaCorTintometricoProps = {
    filtro: FiltroPesquisaCorTintometrico;
    dadosTabelaPesquisaCor: PagedMessageResponse<DadoPesquisaCorTintometrico>
    onPesquisar: (filtro: FiltroPesquisaCorTintometrico) => void;
    onAdicionar: (produtos: string[]) => void;
    fabricantes: ListaSistemaTintometrico[];
    orcamentoForaModuloVendas: boolean;
    somenteLeitura: boolean;
    processando?: boolean
};


export type FiltroPesquisaCorTintometrico = {
    CodigoCor?: number;
    NomeCor?: string;
    CodigoFabricanteSistemaTintometrico?: number[];
    NumeroPagina?: number,
    TamanhoPagina?: number
};

export type DadoPesquisaCorTintometrico = {
    CodigoProduto: string;
    CodigoCor: number;
    CodigoCorExterno: string;
    Cor: string;
    Fornecedor: string;
    ProdutoFinal: string;
    Base: string;
    LitragemEmbalagem: string;
    Quantidade: number;
    PrecoVenda: number;
    
}

const corSelecionado = globalMU.sessionStorage.getData("UsuarioLogado")?.CorFundo
const textoSelecionado = globalMU.sessionStorage.getData("UsuarioLogado")?.CorTexto

export const PesquisaCorTintometrico = (props: PesquisaCorTintometricoProps) => {
    const [produtosSelecionados, setProdutosSelecionados] = useState([])
    const [quantidades, setQuantidades] = useState<{[key: string]: number}>({})
    const onToggleSelecionarProduto = (key: string) => {
        if(produtosSelecionados.includes(key))
            setProdutosSelecionados(produtosSelecionados.filter(i => i != key))
        else
            setProdutosSelecionados(produtosSelecionados.concat(key))
    }
    const formik = useFormik({
        initialValues: { ...props.filtro },
        onSubmit: (values, { }) => { props.onPesquisar(formik.values) },
        enableReinitialize: true,
    });

    const onChangeQuantidade = (key: string, value: number) => {
        setQuantidades({...quantidades, [key]: value})
    }

    const codigoCor = <>
        <div className="_flex _py-2 _items-center">
            <label className="_w-[160px] _pr-[10px]  _text-right _font-normal">Código da Cor do Fabricante</label>
            <div><input
                className={clsx(estilosInputs.inputPadrao, "_w-[200px]")}
                name="CodigoCor"
                id="CodigoCor"
                type="text"
                disabled={props.processando}
                maxLength={254}
                value={(formik.values.CodigoCor) ?? ""}
                onChange={formik.handleChange}
            /></div>
        </div>
    </>

    const nomeCor = <>
        <div className="_flex _py-2">
            <label className="_w-[160px] _pr-[10px] _text-right _font-normal">Nome da Cor</label>
            <input
                className={clsx(estilosInputs.inputPadrao, "_w-[280px]")}
                name="NomeCor"
                id="NomeCor"
                type="text"
                disabled={props.processando}
                maxLength={254}
                value={(formik.values.NomeCor) ?? ""}
                onChange={formik.handleChange}
            />
        </div>
    </>

    const nomeFornecedor = <>
        <div className="_flex _py-2">
            <label className="_w-[160px] _py-2 _pr-[10px]  _text-right _font-normal">Nome do Fabricante</label>
            <select multiple
                id="PesquisaCorTintometrico_ListaFornecedores"
                className={clsx(estilosInputs.select, "_h-auto")}
                value={(props.fabricantes?.filter(fabricante => formik.values.CodigoFabricanteSistemaTintometrico?.includes(fabricante.Codigo))?.map(i => i.Codigo.toString())) ?? ""}
                size={props.fabricantes?.length}
                disabled={props.processando}
                onChange={(e) => {
                    const fabricantesSelecionados = Array.from(e.target.selectedOptions).map((o) => (Number(o.value)));
                    formik.setFieldValue("CodigoFabricanteSistemaTintometrico", fabricantesSelecionados);
                }}
            >
                {props.fabricantes.map((d) => (
                    <option key={d.Codigo} value={d.Codigo}>
                        {d.Descricao}
                    </option>
                ))}
            </select>
        </div>
    </>

    const pesquisar = <>
        <div className="_my-2 _mr-2">
            <button
                 id="PesquisaCorTintometrico_botaoPesquisar"
                className={clsx(estilosBotoes.botaoPrimario, 'no-global-button')}
                disabled={props.processando}
            >
                Pesquisar
            </button>
        </div>
    </>
    
    const adicionar = <>
        <div className="_my-2 _mr-2">
            <button type="button"
                className={clsx(estilosBotoes.botaoPrimario, 'no-global-button')}
                onClick={() => props.onAdicionar(produtosSelecionados.map(p => `${p}|${quantidades[p]}`)) }
                disabled={props.processando}
            >
                Adicionar
            </button>
        </div>
    </>

    const headerTabelaCorTintometrico = () => {
        return  <>
            <th className="!_text-left">Código da Cor do Fabricante</th>
            <th className="!_text-left">Cor</th>
            <th className="!_text-left">Fornecedor</th>
            <th className="!_text-left">Produto Final</th>
            <th className="!_text-left">Base</th>
            <th className="!_text-left">Litragem (Embalagem)</th>
            <th className="!_text-right">Quantidade</th>
            <th className="!_text-right">Preço de Venda</th>
        </>
    }

    const itemTabelaCorTintometrico = (cor: DadoPesquisaCorTintometrico) => {
        return <>
            <td className="_text-left" onClick={() => onToggleSelecionarProduto(cor.CodigoCor+'|'+cor.CodigoProduto)}>{cor.CodigoCorExterno}</td>
            <td className="_text-left" onClick={() => onToggleSelecionarProduto(cor.CodigoCor+'|'+cor.CodigoProduto)}>{cor.Cor}</td>
            <td className="_text-left" onClick={() => onToggleSelecionarProduto(cor.CodigoCor+'|'+cor.CodigoProduto)}>{cor.Fornecedor}</td>
            <td className="_text-left" onClick={() => onToggleSelecionarProduto(cor.CodigoCor+'|'+cor.CodigoProduto)}>{cor.ProdutoFinal}</td>
            <td className="_text-left" onClick={() => onToggleSelecionarProduto(cor.CodigoCor+'|'+cor.CodigoProduto)}>{cor.Base}</td>
            <td className="_text-left" onClick={() => onToggleSelecionarProduto(cor.CodigoCor+'|'+cor.CodigoProduto)}>{cor.LitragemEmbalagem}</td>
            <td className="_text-right">
            <InputNumerico 
                    valor={quantidades[cor.CodigoCor+'|'+cor.CodigoProduto]}
                    onValorModificado={(valor) => onChangeQuantidade(cor.CodigoCor+'|'+cor.CodigoProduto, valor)}
                    numeroCasasDecimais={3}
                    selecionaValorOnFocus={true}
                    disabled={props.orcamentoForaModuloVendas || props.somenteLeitura}
                    />
            </td>
            <td className="_text-right" onClick={() => onToggleSelecionarProduto(cor.CodigoCor+'|'+cor.CodigoProduto)}>{globalMU.formatarValorNumerico(cor.PrecoVenda, 2)}</td>
        </>
    }


    const tabelaCorTintometrico = <>
        <div className={clsx(estilosTabelas.containerRolavel, "_my-2")}>
            <table className={clsx(estilosTabelas.tabela, "_w-full")}
                id="PesquisaCorTintometrico_tabela_Cores">
                <thead>
                    <tr>{headerTabelaCorTintometrico()}</tr>
                </thead>
                <tbody>
                    {props.dadosTabelaPesquisaCor?.Entities?.map((value) => (
                        <tr key={value.CodigoCor} className={estilosTabelas.linhaClicavel}
                        style={
                            produtosSelecionados.includes(value.CodigoCor+'|'+value.CodigoProduto)
                              ? {
                                backgroundColor: corSelecionado,
                                color: textoSelecionado,
                              }
                              : {}
                          }
                           >{itemTabelaCorTintometrico(value)}</tr>
                    ))}
                </tbody>
            </table>
        </div>

    </>

    const paginacao = <Paginacao
        paginaAtual={props.dadosTabelaPesquisaCor?.ActualPage}
        totalPaginas={props.dadosTabelaPesquisaCor?.PageCount}
        desabilitarPaginacao={props.processando}
        id="PesquisaCorTintometrico_Paginacao"
        onAlterarListaSelecionada={(numeroPagina) => props.onPesquisar({ ...formik.values, NumeroPagina: numeroPagina })}
    />

    return (
        <>
            <form onSubmit={(e) => {
                e.preventDefault();
                formik.handleSubmit();
            }}>
                {codigoCor}
                {nomeCor}
                {nomeFornecedor}
            

                <div className="_flex">
                    {pesquisar}
                    {!props.orcamentoForaModuloVendas && !props.somenteLeitura && props.dadosTabelaPesquisaCor?.Entities?.length > 0 && adicionar}
                </div>
            </form>

            {props.dadosTabelaPesquisaCor?.Entities?.length > 0 && tabelaCorTintometrico}

            {props.dadosTabelaPesquisaCor?.PageCount > 1 && (
                paginacao
            )}
            {props.dadosTabelaPesquisaCor?.Entities?.length > 0 &&<div className="_flex">
                    {!props.orcamentoForaModuloVendas && !props.somenteLeitura && adicionar}
                </div>
            }
            {<section style={{ marginBottom: "100px" }} />}
        </>
    );
}